import { apiHolder, apis, getIn18Text } from 'api';
import { reduxMessage, thunkHelperFactory } from '@web-common/utils/redux_utils';
import { asyncMailList, formateMailList, getAdvanceSearchReqParams_sd, getSearchListReqParams_sd, getSearchListReqParams_sd_more, separateUpdateIdAndStore, } from '@web-mail/state/customize';
import { sliceStateCheck } from '@web-mail/utils/slice';
import { getMailListByIdFromStore } from '@web-mail/util';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
import { FolderThunks_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/folderThunks_sd';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const ReducerName = 'SubordinateSearchReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'searchMailList_sd',
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const { sliceId, startIndex = 0 } = params;
        const { mailSearchKey, searchingRequestId } = state.subordinate[sliceId];
        const query = getSearchListReqParams_sd(state, startIndex, sliceId);
        const searchingId = searchingRequestId && searchingRequestId > -1 ? searchingRequestId : undefined;
        params.noCache = true;
        if (!query) {
            console.error('searchMailList_sd query is null');
            return;
        }
        return mailApi.doSearchMail_sd(mailSearchKey, Object.assign({}, query), searchingId);
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, noCache, sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        const searchListOld = state.subordinate[sliceId].searchList;
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        let list = startIndex === 0 ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver', 'entry.brief'],
            sliceId,
            type: 'subordinate',
        });
        if (startIndex === 0) {
            state.subordinate[sliceId].scrollTop = 0;
        }
        state.subordinate[sliceId].searchTotal = res.total;
        state.subordinate[sliceId].searchLoading = false;
        state.subordinate[sliceId].searchLoadingMore = false;
        state.subordinate[sliceId].listLoading = false;
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, value, startIndex } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (state.subordinate[sliceId]) {
            state.subordinate[sliceId].searchLoading = true;
            if (startIndex > 0) {
                state.subordinate[sliceId].searchLoadingMore = true;
            }
            if (value) {
                state.subordinate[sliceId].mailSearchKey = value;
            }
            state.subordinate[sliceId].mailSearchState = 'server';
            state.subordinate[sliceId].isSearchRecorded = false;
        }
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (state.subordinate[sliceId]) {
            state.subordinate[sliceId].searchLoading = false;
            state.subordinate[sliceId].searchLoadingMore = false;
            state.subordinate[sliceId].listLoading = false;
        }
    },
});
thunkHelper({
    name: 'advancedSearchMailList_sd',
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, startIndex } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        state.subordinate[sliceId].advancedSearchLoading = true;
        state.subordinate[sliceId].mailSearchState = 'advanced';
    },
    request: async (params, thunkAPI) => {
        const { startIndex = 0, sliceId } = params;
        const state = thunkAPI.getState().mailReducer;
        const searchModel = getAdvanceSearchReqParams_sd(state, startIndex, sliceId);
        const { subordinateId, relationEmailList = [] } = state.subordinate[sliceId].selectedFolder;
        const subEmails = relationEmailList.map(item => item.email);
        if (!subordinateId || !searchModel) {
            console.error('[advancedSearchMailList_sd] colleagueAccId or searchModel  is null');
            return;
        }
        return mailApi.doAdvanceSearchMail_sd(searchModel, subordinateId, subEmails);
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, noCache, sliceId } = params;
        const searchListOld = state.subordinate[sliceId].searchList;
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        state.subordinate[sliceId].mailListInitIsFailed = false;
        let list = startIndex === 0 ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver'],
            sliceId,
            type: 'subordinate',
        });
        if (startIndex === 0) {
            state.subordinate[sliceId].scrollTop = 0;
        }
        state.subordinate[sliceId].searchTotal = res.total;
        state.subordinate[sliceId].searchLoading = false;
        state.subordinate[sliceId].listLoading = false;
        state.subordinate[sliceId].advancedSearchLoading = false;
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, showLoading = true } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        state.subordinate[sliceId].searchLoading = false;
        state.subordinate[sliceId].listLoading = false;
        state.subordinate[sliceId].advancedSearchLoading = false;
        state.subordinate[sliceId].mailListInitIsFailed = true;
        if (showLoading) {
            reduxMessage.error({
                content: getIn18Text('JIAZAISHIBAI'),
            });
        }
    },
});
thunkHelper({
    name: 'searchMailList_sd_more',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { sliceId, startIndex = 0 } = params;
        const { mailSearchKey } = state.subordinate[sliceId];
        if (!mailSearchKey.trim()) {
            console.error('searchMailList_sd_more query is null');
            return;
        }
        const query = getSearchListReqParams_sd_more(state, startIndex, sliceId);
        const res = await mailApi.doAdvanceSearchMail_sd_more(query);
        if ((res === null || res === void 0 ? void 0 : res.code) && +(res === null || res === void 0 ? void 0 : res.code) === 510) {
            reduxMessage.error({
                content: getIn18Text('QINGSHUAXINXSLB'),
            });
            dispatch(FolderThunks_sd.loadFolderData_sd({
                noCache: true,
                showLoading: false,
                sliceId,
            }));
        }
        return res;
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        const { searchList: searchListOld, more_searchingRequestId } = state.subordinate[sliceId];
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        if (!more_searchingRequestId || (res.searchId && more_searchingRequestId === res.searchId)) {
            let list = startIndex === 0 ? [] : searchList;
            list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
            separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
                key: 'search',
                exclude: ['entry.title', 'receiver', 'entry.brief'],
                sliceId,
                type: 'subordinate',
            });
            if (startIndex === 0) {
                state.subordinate[sliceId].scrollTop = 0;
            }
            if (res.hasMore) {
                state.subordinate[sliceId].searchTotal = state.subordinate[sliceId].searchTotal + res.total + 1;
            }
            else {
                state.subordinate[sliceId].searchTotal = state.subordinate[sliceId].searchTotal + res.total;
            }
            state.subordinate[sliceId].more_searchingRequestId = res.searchId;
        }
        state.subordinate[sliceId].more_searchEmails = res.searchEmails || [];
        state.subordinate[sliceId].more_searchLoading = false;
        state.subordinate[sliceId].listLoading = false;
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, value, startIndex, resetActiveIds } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (state.subordinate[sliceId].more_searchLoading) {
            console.error('searchMailList_sd_more is runing');
            return;
        }
        if (state.subordinate[sliceId]) {
            state.subordinate[sliceId].more_searchLoading = true;
            if (startIndex > 0) {
            }
            else if (startIndex === 0) {
                state.subordinate[sliceId].searchTotal = 0;
                state.subordinate[sliceId].more_searchingRequestId = null;
                if (resetActiveIds) {
                    state.subordinate[sliceId].activeIds = [];
                }
            }
            if (value) {
                state.subordinate[sliceId].mailSearchKey = value;
            }
            state.subordinate[sliceId].mailSearchState = 'more_server';
            state.subordinate[sliceId].isSearchRecorded = false;
        }
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (state.subordinate[sliceId]) {
            state.subordinate[sliceId].more_searchLoading = false;
            state.subordinate[sliceId].listLoading = false;
        }
    },
});
thunkHelper({
    name: 'advancedSearchMailList_sd_more',
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, startIndex = 0, resetActiveIds } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (state.subordinate[sliceId].more_advancedSearchLoading) {
            console.error('advancedSearchMailList_sd_more is runing');
            return;
        }
        if (startIndex === 0) {
            state.subordinate[sliceId].searchTotal = 0;
            state.subordinate[sliceId].more_searchingRequestId = null;
            if (resetActiveIds) {
                state.subordinate[sliceId].activeIds = [];
            }
        }
        state.subordinate[sliceId].more_advancedSearchLoading = true;
        state.subordinate[sliceId].mailSearchState = 'more_advanced';
    },
    request: async (params, thunkAPI) => {
        const { startIndex = 0, sliceId } = params;
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const query = getSearchListReqParams_sd_more(state, startIndex, sliceId);
        const res = await mailApi.doAdvanceSearchMail_sd_more(query);
        if ((res === null || res === void 0 ? void 0 : res.code) && +(res === null || res === void 0 ? void 0 : res.code) === 510) {
            reduxMessage.error({
                content: getIn18Text('QINGSHUAXINXSLB'),
            });
            dispatch(FolderThunks_sd.loadFolderData_sd({
                noCache: true,
                showLoading: false,
                sliceId,
            }));
        }
        return res;
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { startIndex = 0, sliceId } = params;
        const searchListOld = state.subordinate[sliceId].searchList;
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        state.subordinate[sliceId].mailListInitIsFailed = false;
        let list = startIndex === 0 ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res.entities) : res.entities;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver'],
            sliceId,
            type: 'subordinate',
        });
        if (startIndex === 0) {
            state.subordinate[sliceId].scrollTop = 0;
        }
        if (res.hasMore) {
            state.subordinate[sliceId].searchTotal = state.subordinate[sliceId].searchTotal + res.total + 1;
        }
        else {
            state.subordinate[sliceId].searchTotal = state.subordinate[sliceId].searchList.length + res.total;
        }
        state.subordinate[sliceId].more_searchEmails = res.searchEmails || [];
        state.subordinate[sliceId].more_searchingRequestId = res.searchId;
        state.subordinate[sliceId].more_searchLoading = false;
        state.subordinate[sliceId].listLoading = false;
        state.subordinate[sliceId].more_advancedSearchLoading = false;
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId, showLoading = true } = params;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        state.subordinate[sliceId].more_searchLoading = false;
        state.subordinate[sliceId].listLoading = false;
        state.subordinate[sliceId].more_advancedSearchLoading = false;
        state.subordinate[sliceId].mailListInitIsFailed = true;
        if (showLoading) {
            reduxMessage.error({
                content: getIn18Text('JIAZAISHIBAI'),
            });
        }
    },
});
thunkHelper({
    name: 'doExtractMailFromAI',
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { searchPayload } = params || {};
        const { searchUrl } = searchPayload || {};
        const sliceId = tabId.subordinate;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        if (!!state.subordinate[sliceId].mailSearchState && state.subordinate[sliceId].mailSearchState !== 'more_AI') {
            state.subordinate[sliceId].mailSearchState_old = state.subordinate[sliceId].mailSearchState;
        }
        state.subordinate[sliceId].mailSearchState = 'more_AI';
        if (searchUrl) {
            state.subordinate[sliceId].searchUrl_sd = searchUrl;
        }
        state.subordinate[sliceId].listLoading = true;
    },
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const sliceId = tabId.subordinate;
        const searchUrlOld = state.subordinate[sliceId].searchUrl_sd;
        const { searchPayload } = params || {};
        const { searchId, searchUrl } = searchPayload || {};
        const url = searchUrl || searchUrlOld;
        return mailApi.getMailListFromSdAI({ searchUrl: url, searchId });
    },
    fulfilled: (state, action) => {
        const res = action.payload;
        const sliceId = tabId.subordinate;
        const startIndex = 0;
        const searchListOld = state.subordinate[sliceId].searchList;
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        let list = startIndex === 0 ? [] : searchList;
        list = list.length > 0 ? asyncMailList(list, res) : res;
        separateUpdateIdAndStore(state, 'searchList', formateMailList(list), {
            key: 'search',
            exclude: ['entry.title', 'receiver'],
            sliceId,
            type: 'subordinate',
        });
        if (startIndex === 0) {
            state.subordinate[sliceId].scrollTop = 0;
        }
        state.subordinate[sliceId].searchTotal = res.length;
        state.subordinate[sliceId].listLoading = false;
    },
    rejected: (state, action) => {
        const sliceId = tabId.subordinate;
        if (!sliceStateCheck(state, sliceId, 'subordinate')) {
            return;
        }
        state.subordinate[sliceId].listLoading = false;
        state.subordinate[sliceId].mailListInitIsFailed = true;
    },
});
export const SearchThunks_sd = Thunks;
export const SearchExtraReducersList_sd = ReducersList;
